<template>
  <QPageContainer>
    <QPage class="recruitment-candidates-list">
      <ExtracadabraCard :title="$t('ETAB.PAGES.CANDIDATE.@LOCKED_DEMAND_TITLE')">
        <div class="text-left q-ml-md q-mt-md">
          {{ $t("ETAB.PAGES.CANDIDATE.@LOCKED_DEMAND_DESCRIPTION") }}
        </div>
        <div class="text-center">
          <QBtn color="primary" text-color="white" label="Recrutez sans limite" class="q-my-md" no-caps @click="activateDemand" />
        </div>
      </ExtracadabraCard>
    </QPage>
  </QPageContainer>
</template>

<script>
  import { ETAB_ROUTES } from "@etab/config";

  export default {
    computed: {
      demandId() {
        return this.$route.params.demandId;
      },
      demandType() {
        return this.$route.params.demandType;
      },
    },
    methods: {
      async activateDemand() {
        await this.$router
          .push({
            name: ETAB_ROUTES.dashboard.recruitment.permanent.activation.payment.name,
            params: { demandId: this.demandId, demandType: this.demandType },
          })
          .catch((suppressedError) => {});
      },
    },
  };
</script>
recruitment
